import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Handles the Google OAuth redirect.
 *
 * The backend redirects here after a successful OAuth flow:
 *   {FRONTEND_URL}/auth/callback?token={session_token}
 *
 * We store the token in localStorage so the axios client and AuthContext
 * can send it as a Bearer header on all subsequent API requests — this
 * bypasses third-party cookie restrictions between Railway (backend) and
 * Vercel (frontend).
 */
export default function AuthCallback() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const { checkAuth } = useAuth();

    useEffect(() => {
        const token = params.get('token');
        if (token) {
            localStorage.setItem('session_token', token);
        }
        // Refresh auth state then redirect to home, even if token was missing.
        checkAuth().finally(() => navigate('/', { replace: true }));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="flex h-screen items-center justify-center bg-background">
            <Loader2 className="w-6 h-6 animate-spin text-primary" />
        </div>
    );
}
